import { Box, Button, Stack } from '@mui/material';

import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';

import ClaimRow from '@/karehero-app/tell-us-once/intake/ClaimRow';

import StatusBar from '@/designs-dev/device/StatusBar';
import HomeIndicator from '@/designs-dev/device/HomeIndicator';
import ScreenRoot from '@/components/wrapped/ScreenRoot';
import AccountBar, { type Account } from '@/karehero-app/access/AccountBar';
import { FILLED } from '@/karehero-app/tell-us-once/intake/content';
import { PAGE_HEADER_TOP } from '@/karehero-app/shell/layout';

const SCREEN_PX = 3;

const FilledScreen = ({
  onCalculator,
  onNext,
  account,
}: {
  onCalculator?: () => void;
  onNext?: () => void;
  /** The app bar. See StepScreen's own `account`. */
  account?: Account;
}) => (
  <ScreenRoot>
    <StatusBar />
    {account && <AccountBar {...account} />}

    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', px: SCREEN_PX, pb: 2 }}>
      <Box sx={{ pt: PAGE_HEADER_TOP }}>
        <Stack spacing={3}>
          <PageHeader
            title={FILLED.title}
            description={FILLED.description}
            variant='h2'
          />

          <Stack spacing={1.5}>
            <ClaimRow
              icon={FILLED.lead.icon}
              name={FILLED.lead.name}
              description={FILLED.lead.description}
              count={`${FILLED.lead.answered} of ${FILLED.lead.total} answered`}
              lead
              onClick={onCalculator}
            />
            {FILLED.items.map((item) => (
              <ClaimRow
                key={item.name}
                icon={item.icon}
                name={item.name}
                description={item.description}
                count={`${item.answered} of ${item.total} answered`}
              />
            ))}
          </Stack>
        </Stack>
      </Box>
    </Box>

    {/* The claims are a read, not a task list, so the way on is a plain Next:
        what to actually do about them is waiting on the actions list. */}
    <Box sx={{ flexShrink: 0, px: SCREEN_PX, py: 1.5 }}>
      <Button variant='contained' size='large' fullWidth onClick={onNext}>
        Next
      </Button>
    </Box>

    <HomeIndicator />
  </ScreenRoot>
);

export default FilledScreen;
